module.exports = __webpack_public_path__ + "01_long_yellow.f9b87e8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_long_yellow.png
// module id = 8rAr
// module chunks = 0